import React, { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";

import { getSalesPrint } from "./services/sales.services";
import { formatIndianNumber } from "../../_helper/helper";

const SalesEwayPrint = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const params = useParams();
  const queryParam = new URLSearchParams(location.search);
  const isPrint = queryParam.get("print");
  const sale_guid = params?.sale_guid;
  const SalesPrintDetail = useAppSelector(
    (state) => state.sales.SalesPrintDetail
  );
  // const [tableHeight, setTableHeight] = React.useState<any>(null);

  useEffect(() => {
    if (sale_guid) {
      const handleOrderPrint = async () => {
        await dispatch(getSalesPrint(sale_guid));
      };
      handleOrderPrint();
    }
  }, [sale_guid]);

  useEffect(() => {
    if (
      !SalesPrintDetail?.isenvoicegenerate &&
      !!SalesPrintDetail?.isinvoicecancel
    ) {
      if (isPrint === "1") {
        window.print();
      }
    }
  }, [SalesPrintDetail]);

  const handleImageLoad = () => {
    setTimeout(() => {
      if (isPrint === "1") {
        window.print();
      }
    }, 1000);
  };

  // let totalAmount = 0;
  // let totalTaxAmount = 0;

  // SalesPrintDetail?.sales_items &&
  //   SalesPrintDetail?.sales_items.length > 0 &&
  //   SalesPrintDetail?.sales_items?.map(
  //     (item: any) => (totalAmount += item?.amount)
  //   );

  // SalesPrintDetail?.gst_details_hsn &&
  //   SalesPrintDetail?.gst_details_hsn?.length > 0 &&
  //   SalesPrintDetail?.gst_details_hsn?.map((gstamount: any) => {
  //     const totaltax =
  //       gstamount?.total_taxable_amount &&
  //       gstamount?.gst &&
  //       (gstamount?.total_taxable_amount * gstamount?.gst) / 100;
  //     totalTaxAmount += totaltax || 0;
  //   });

  return (
    <div className="sales-print-page">
      {/* <p className="fw-600 text-center mb-1">
        <i>(ORIGINAL FOR RECEPIENT)</i>
      </p> */}
      <h6 className="text-center fw-600">
        {/* {SalesPrintDetail?.voucher_type_id === 2
          ? "Bill Of Supply"
          : "Tax Invoice"} */}
        e-Way Bill
      </h6>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "5px",
        }}
      >
        <div>
          <div style={{ padding: "5px 0" }}>
            <p className="p-0 m-0">
              <span style={{ width: 55, display: "inline-block" }}>
                Doc No{" "}
              </span>{" "}
              :{" "}
              <span className="fw-600 p-0">
                {SalesPrintDetail?.invoice_no_string}
              </span>
            </p>
            <p className="p-0 m-0">
              <span style={{ width: 55, display: "inline-block" }}>Date </span>{" "}
              :{" "}
              <span className="fw-600 p-0">
                {SalesPrintDetail?.invoice_date}
              </span>
            </p>{" "}
            <br />
            <p className="p-0 m-0">
              <span style={{ width: 55, display: "inline-block" }}>IRN </span> :{" "}
              <span className="fw-600 p-0">{SalesPrintDetail?.irn}</span>
            </p>
            <p className="p-0 m-0">
              <span style={{ width: 55, display: "inline-block" }}>
                Ack No.{" "}
              </span>{" "}
              : <span className="fw-600 p-0">{SalesPrintDetail?.ack_no}</span>
            </p>
            <p className="p-0 m-0">
              <span style={{ width: 55, display: "inline-block" }}>
                Ack Date{" "}
              </span>{" "}
              : <span className="fw-600 p-0">{SalesPrintDetail?.ack_date}</span>
            </p>
          </div>
        </div>
        <div>
          <p className="m-0 p-0 text-center">e-Way Bill</p>
          <div style={{ textAlign: "end" }}>
            <img
              style={{ objectFit: "contain", height: "120px" }}
              src={SalesPrintDetail?.eway_qr_code}
              alt="qr"
              onLoad={handleImageLoad}
            />
          </div>
        </div>
      </div>
      <hr style={{ margin: "5px 0" }} />
      <div>
        <h6 style={{ margin: "0" }}>1. e-Way Bill Details</h6>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "5px",
          }}
        >
          <div style={{ padding: "5px 0" }}>
            <p className="p-0 m-0">
              <span style={{ width: 100, display: "inline-block" }}>
                e-Way Bill No.{" "}
              </span>{" "}
              : <span className="fw-600 p-0">{SalesPrintDetail?.ewb_no}</span>
            </p>
            <p className="p-0 m-0">
              <span style={{ width: 100, display: "inline-block" }}>
                Generated By{" "}
              </span>{" "}
              : <span className="fw-600 p-0">24AAACH5100R1ZN</span>
            </p>{" "}
            <p className="p-0 m-0">
              <span style={{ width: 100, display: "inline-block" }}>
                Supply Type{" "}
              </span>{" "}
              : <span className="fw-600 p-0">Outward</span>
            </p>
          </div>
          <div style={{ padding: "5px 0" }}>
            <p className="p-0 m-0">
              <span style={{ width: 100, display: "inline-block" }}>Mode </span>{" "}
              :{" "}
              <span className="fw-600 p-0">{SalesPrintDetail?.trans_mode}</span>
            </p>
            <p className="p-0 m-0">
              <span style={{ width: 100, display: "inline-block" }}>
                Approx Distance{" "}
              </span>{" "}
              :{" "}
              <span className="fw-600 p-0">
                {SalesPrintDetail?.distance} KM
              </span>
            </p>{" "}
            <p className="p-0 m-0">
              <span style={{ width: 100, display: "inline-block" }}>
                Transaction Type
              </span>{" "}
              : <span className="fw-600 p-0">Regular</span>
            </p>
          </div>
          <div style={{ padding: "5px 0" }}>
            <p className="p-0 m-0">
              <span style={{ width: 100, display: "inline-block" }}>
                Generated Date.{" "}
              </span>{" "}
              : <span className="fw-600 p-0">{SalesPrintDetail?.ewb_date}</span>
            </p>
            <p className="p-0 m-0">
              <span style={{ width: 100, display: "inline-block" }}>
                Valid Upto{" "}
              </span>{" "}
              :{" "}
              <span className="fw-600 p-0">
                {SalesPrintDetail?.ewb_valid_till}
              </span>
            </p>{" "}
          </div>
        </div>
      </div>
      <hr style={{ margin: "5px 0" }} />
      <div>
        <h6 style={{ margin: "0" }}>2. Address Details</h6>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "5px",
          }}
        >
          <div style={{ padding: "5px 0", flex: 1 }}>
            <h6 style={{ marginBottom: "5px" }}>From</h6>
            <p>
              Harihar Foods Pvt. Ltd. <br />
              GSTIN : 24AAACH5100R1ZN <br />
              Gujarat
            </p>
            <h6>Dispatch From</h6>
            <p style={{ marginBottom: "5px" }}>
              519/1, Nr Ramol Police Chowky , Phase IV, G.I.D.C. Vatva, <br />{" "}
              Ahmedabad 382445 , Tel (Off) 079-25841773/25840855 , <br />
              FSSAI No: 10012021000359 , AHMEDABAD Gujarat 382445
            </p>
          </div>
          <div style={{ padding: "5px 0", flex: 1 }}>
            <h6 style={{ marginBottom: "5px" }}>To</h6>
            <p>
              {SalesPrintDetail?.account_name} <br />
              GSTIN : {SalesPrintDetail?.gst_no} <br />
              {SalesPrintDetail?.state_name}
            </p>
            <h6>Ship To</h6>
            <p style={{ marginBottom: "5px" }}>
              {SalesPrintDetail?.address1} {SalesPrintDetail?.city_name}
              {SalesPrintDetail?.city_name &&
                SalesPrintDetail?.pincode &&
                " - "}
              {SalesPrintDetail?.pincode}
              {SalesPrintDetail?.pincode &&
                SalesPrintDetail?.district_name &&
                " , "}
              {SalesPrintDetail?.district_name}
              {SalesPrintDetail?.district_name &&
                SalesPrintDetail?.state_name &&
                " , "}
              {SalesPrintDetail?.state_name} M.No.:{" "}
              {SalesPrintDetail?.mobile_number}
              {SalesPrintDetail?.mobile_number &&
                SalesPrintDetail?.alternet_mobile_no &&
                ", "}
              {SalesPrintDetail?.alternet_mobile_no} <br />
            </p>
          </div>
        </div>
      </div>
      <hr style={{ margin: "5px 0" }} />
      <div>
        <h6 style={{ margin: "0" }}>3. Goods Details</h6>
        <hr style={{ margin: "5px 0" }} />
        <table style={{ width: "100%" }}>
          <tr style={{ borderBottom: "1px solid lightgrey" }}>
            <th style={{ paddingBottom: "5px" }}>HSN Code</th>
            <th style={{ paddingBottom: "5px" }}>Product Name & Desc</th>
            <th style={{ paddingBottom: "5px" , textAlign: "end"}}>Quantity</th>
            <th style={{ paddingBottom: "5px" , textAlign: "end"}}>Taxable Amt</th>
            <th style={{ paddingBottom: "5px" , textAlign: "end"}}>
              Tax Rate {SalesPrintDetail?.state_id === 1 ? `(C + S)` : `(I)`}{" "}
            </th>
          </tr>

          {SalesPrintDetail?.sales_items?.map((item: any, index: number) => (
            <tr key={index}>
              <td>
                <strong>{item.hsn_sac_code}</strong>
              </td>
              <td>{item?.product_name}</td>
              <td style={{ textAlign: "end" }}>
                <strong>{item?.shipped_quantity}</strong> {" "}{item?.unit_name?.toUpperCase()}
              </td>
              <td style={{ textAlign: "end" }}>{formatIndianNumber(item?.amount)}</td>
              <td style={{ textAlign: "end" }}>
                {SalesPrintDetail?.state_id === 1 ? (
                  <>
                    {item?.cgst_per} % + {item?.sgst_per} %
                  </>
                ) : (
                  <>{item?.igst_per} %</>
                )}
              </td>
            </tr>
          ))}
        </table>
      </div>
      <hr style={{ margin: "5px 0" }} />
      <div>
        <div
          style={{
            padding: "5px 0",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <p className="p-0 m-0">
            <span style={{ width: 110, display: "inline-block" }}>
              Total Taxable Amt.{" "}
            </span>{" "}
            :{" "}
            <span className="fw-600 p-0">
              {formatIndianNumber(SalesPrintDetail?.taxable_amount)}
            </span>
          </p>
          <p className="p-0 m-0">
            <span style={{ width: 90, display: "inline-block" }}>
              Other Amount{" "}
            </span>{" "}
            :{" "}
            <span className="fw-600 p-0">
              {formatIndianNumber(SalesPrintDetail?.round_off)}
            </span>
          </p>{" "}
          <p className="p-0 m-0">
            <span style={{ width: 100, display: "inline-block" }}>
              Total Inv Amount{" "}
            </span>{" "}
            :{" "}
            <span className="fw-600 p-0">
              {formatIndianNumber(SalesPrintDetail?.total_amount)}
            </span>
          </p>
        </div>
        {SalesPrintDetail?.state_id === 1 ? (
          <div style={{ padding: "5px 0" }}>
            <p className="p-0 m-0">
              <span style={{ width: 110, display: "inline-block" }}>
                CGST Amount{" "}
              </span>{" "}
              :{" "}
              <span className="fw-600 p-0">
                {formatIndianNumber(SalesPrintDetail?.cgst)}
              </span>
            </p>
            <p className="p-0 m-0">
              <span style={{ width: 110, display: "inline-block" }}>
                SGST Amount{" "}
              </span>{" "}
              :{" "}
              <span className="fw-600 p-0">
                {formatIndianNumber(SalesPrintDetail?.sgst)}
              </span>
            </p>{" "}
          </div>
        ) : (
          <div style={{ padding: "5px 0" }}>
            <p className="p-0 m-0">
              <span style={{ width: 110, display: "inline-block" }}>
                IGST Amount{" "}
              </span>{" "}
              :{" "}
              <span className="fw-600 p-0">
                {formatIndianNumber(SalesPrintDetail?.igst)}
              </span>
            </p>
          </div>
        )}
      </div>
      <hr style={{ margin: "5px 0" }} />
      <div>
        <h6 style={{ margin: "0" }}>4. Transportation Details</h6>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "5px",
          }}
        >
          <div style={{ padding: "5px 0" }}>
            <p className="p-0 m-0">
              <span style={{ width: 90, display: "inline-block" }}>
                Transporter ID.{" "}
              </span>{" "}
              : <span className="fw-600 p-0">{SalesPrintDetail?.trans_id}</span>
            </p>
            <p className="p-0 m-0">
              <span style={{ width: 90, display: "inline-block" }}>Name </span>{" "}
              :{" "}
              <span className="fw-600 p-0">{SalesPrintDetail?.trans_name}</span>
            </p>{" "}
          </div>
          <div style={{ padding: "5px 0" }}>
            <p className="p-0 m-0">
              <span style={{ width: 50, display: "inline-block" }}>
                Doc No.{" "}
              </span>{" "}
              :{" "}
              <span className="fw-600 p-0">
                {SalesPrintDetail?.invoice_no_string}
              </span>
            </p>
            <p className="p-0 m-0">
              <span style={{ width: 50, display: "inline-block" }}>Date </span>{" "}
              :{" "}
              <span className="fw-600 p-0">
                {SalesPrintDetail?.invoice_date}
              </span>
            </p>{" "}
          </div>
        </div>
      </div>
      <hr style={{ margin: "5px 0" }} />
      <div>
        <h6 style={{ margin: "0" }}>5. Vehicle Details</h6>
        <div
          style={{
            display: "flex",
            alignItems: "flex-end",
            justifyContent: "space-between",
            padding: "5px",
          }}
        >
          <p className="p-0 m-0">
            <span style={{ width: 65, display: "inline-block" }}>
              Vehicle No.{" "}
            </span>{" "}
            : <span className="fw-600 p-0">{SalesPrintDetail?.vehicle_no}</span>
          </p>
          <p className="p-0 m-0">
            <span style={{ width: 40, display: "inline-block" }}>From </span> :{" "}
            <span className="fw-600 p-0">AHMEDABAD</span>
          </p>
          <p className="p-0 m-0">
            <span style={{ width: 60, display: "inline-block" }}>CEWB No </span>{" "}
            :{" "}
            <span className="fw-600 p-0">
              {SalesPrintDetail?.cewbno}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SalesEwayPrint;
